import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IEopDocument, IRecordOfChange, IRecordOfDistribution } from '../models/eopDocument';
import { EopPlanSlug } from '../../app/eop-config/eop-page-config';

type DownloadResponse = { has_error: boolean, message: string, data: { filename: string, file_content: string } };

@Injectable({
    providedIn: 'root'
})
export class EopDownloadService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    // Per-plan download endpoints. Add a plan here + a backend endpoint to
    // extend downloads to more EOPs.
    private downloadEndpointByPlan: { [plan: string]: string } = {
        'al': endpoints.downloadALEop,
        'ms': endpoints.downloadMSEop,
        'ga': endpoints.downloadGAEop,
    };

    downloadEopDocument(plan: EopPlanSlug, buildingId: string, schoolYear: string, eopSection?: string): Observable<DownloadResponse> {
        const endpointTemplate = this.downloadEndpointByPlan[plan] ?? endpoints.downloadALEop;
        const url = environment.apiBaseUrl + endpointTemplate.replace(':buildingId', buildingId);

        let params = new HttpParams().set('school_year', schoolYear);
        if (eopSection) {
            params = params.set('eop_section', eopSection);
        }
        return this.http.get<DownloadResponse>(url, { params }).pipe(
          catchError(this.errorService.handleSavingError)
        );
    }

    downloadALEopDocument(buildingId: string, schoolYear: string, eopSection?: string): Observable<DownloadResponse> {
        return this.downloadEopDocument('al', buildingId, schoolYear, eopSection);
    }

    sendEOP(buildingId: string, schoolYear: string, data: IRecordOfDistribution): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.sendEOP.replace(':buildingId', buildingId);
        
        const params = new HttpParams().set('school_year', schoolYear);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data, { params }).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}